"use client";
import Box from "@mui/material/Box";
import React from "react";
import { AnalyticsEvents, trackEvent } from "~/connectors/analytics.connector";
import useIsClient from "~/hooks/useIsClient";
import { useAudioMiniPlayerState } from "./useAudio";


type Props = {
  width?: number | string;
  height?: number | string;
};

export default function CastButton({ width = 24, height = 24 }: Props) {
  const isClient = useIsClient();
  const { currentSong } = useAudioMiniPlayerState();

  if (!isClient) return null;

  return React.createElement(
    Box,
    {
      onClick: () => {
        try {
          trackEvent(AnalyticsEvents.SONG_PLAYER_CAST_CLICKED, {
            title: currentSong?.title ?? null,
            songId: currentSong?.id ?? null,
          });
        } catch (err) {
          /* ignore analytics errors */
        }
      },
      sx: {
        width,
        height,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        verticalAlign: "middle",
        cursor: "pointer",
      },
    },
    React.createElement("google-cast-launcher", {
      style: {
        display: "block",
        width: "100%",
        height: "100%",
        lineHeight: 0,
      },
      // aria-label helps automated tests identify the element
      "aria-label": currentSong ? `Cast ${currentSong.title}` : "Cast",
    }),
  );
}
